// extracted by mini-css-extract-plugin
module.exports = {"collapseItem":"collapseItem_collapseItem__1kv05","countColor":"collapseItem_countColor__1v-Da"};